import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import AdSection from './components/adSection';
import './solution.scss';
import { SectionWrapper } from '../../theme/layouts/MainLayout';
import { altLtGray, techBlack } from '../../common/utils/constant';
import AppImage from '../../common/features/image';

function Solution() {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="app-wrapper layer">
      <SectionWrapper bg={techBlack}>
        <section className="sol-banner-section">
          <Row>
            <Col md={5} sm={12}>
              <div className='banner-text-section'>
              <div className="section-content">More reach. More ways to amplify results.</div>
              <div className="subsection-content">Make every message count with our full suite of solutions designed for 360° reach.</div>
              </div>
            </Col>
            <Col md={7} sm={12} className='solution-rightside-img'>
              <AppImage src={isMobile ? '/images/solutions/solutions_hero_mobile.png' : '/images/solutions/solutions_hero.png'} alt="More reach. More ways to amplify results." title='More reach. More ways to amplify results.' className="img-style" />
            </Col>
          </Row>
        </section>
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        {/* Reusable Sections */}
        <AdSection
          title="Search Ads"
          subtitle="Get more results from their search."
          description="Search Ads connect your brand with near-purchase shoppers looking for products onsite and using the most popular search engines offsite. Move to the top of their results with highly targeted product ads that turn interest into sales on BestBuy.com and beyond."
          imageSrc={isMobile ? '/images/solutions/solutions_search-ads_mobile.png' : '/images/solutions/solutions_search-ads.png'}
          imageAlt="Search.Ads"
          bulletPoints={['Sponsored Products', 'Paid Search']}
          imagePosition="left"
          firstCol='order-2 order-md-1'
          secondCol='order-1 order-md-2'
        />
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <AdSection
          title="Display Ads"
          subtitle="Stay top of mind every time."
          description="Display Ads use our first-party data to keep your brand front and center with engaging experiences that inspire clicks on BestBuy.com, the Best Buy mobile app and nearly anywhere they browse the web."
          imageSrc={isMobile ? '/images/solutions/solutions_display-ads_mobile.png' : '/images/solutions/solutions_display-ads.png'}
          imageAlt="Display.Ads"
          bulletPoints={['Standard & High-Impact Onsite Display', 'Standard Offsite Display', 'Dynamic Offsite Retargeting']}
          imagePosition="right"
          firstCol='order-1 order-md-1'
          secondCol='order-2 order-md-2'
        />
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <AdSection
          title="Video Ads"
          subtitle="Hit play on creative content that connects."
          description="Video Ads turn our creative into can’t-miss content by reaching the people most likely to connect with your brand while they binge-watch a show, cheer on their favorite team or browse in store at their local Best Buy."
          imageSrc={isMobile ? '/images/solutions/solutions_video-ads_mobile.png' : '/images/solutions/solutions_video-ads.png'}
          imageAlt="Video.Ads"
          bulletPoints={['In-Store TV Wall & PC Monitors', 'Onsite Rich Media', 'Offsite Digital Video', 'Connected TV']}
          imagePosition="left"
          firstCol='order-2 order-md-1'
          secondCol='order-1 order-md-2'
        />
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <AdSection
          title="Social Ads"
          subtitle="Join the conversation and make meaningful connections."
          description="Social Ads connect your brand with top social networks—from Meta to TikTok—with relevant and engaging content in timelines, video feeds, live moments and more."
          imageSrc={isMobile ? '/images/solutions/solutions_social-ads_mobile.png' : '/images/solutions/solutions_social-ads.png'}
          imageAlt="Social.Ads"
          bulletPoints={['Facebook', 'Instagram', 'TikTok', 'Pinterest', 'Snap', 'Reddit']}
          imagePosition="right"
          firstCol='order-1 order-md-1'
          secondCol='order-2 order-md-2'
        />
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>

        <section className="section-2">
          <Row>
            <Col md={5} sm={12} className={`order-2 order-md-1`}>
              <div className='sol-section-left-column'>
              <div className="community-ads-content"><span className='energy-purple'>Community</span> Ads</div>
              <div className="community-subTitle-content ">Creators that influence action.</div>
              <div className="common-subsection-content">Community Ads give you a platform to connect with subscribers, routine readers and followings of all sizes. Whether you’re working with influencers, a network of product reviewers or a trusted publication, you’re connecting with loyal and influential audiences.</div>
              <ul className="custom-bullets">
                {['Influencers', 'Affiliates', 'Onsite Product Reviews'].map((point, index) => (
                  <li key={index} className="pt-1">{point}</li>
                ))}
              </ul>
              </div>
            </Col>
            <Col md={7} sm={12} className={`order-1 order-md-2 solution-rightside-img`}>
              <AppImage src={isMobile ? '/images/solutions/solutions_community-ads_mobile.png' : '/images/solutions/solutions_community-ads.png'} alt={'Community Ads'} title={'Community Ads'} className={`img-style`} />
            </Col>
          </Row>
        </section>

      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <AdSection
          title="Direct Ads"
          subtitle="Targeted messaging that drives results."
          description="Direct Ads bring you to the digital home screens and physical home steps of your audiences with targeted messages throughout your customers’ purchase journeys— from awareness-driving direct mail at home to near-purchase proximity messages in-store."
          imageSrc={isMobile ? '/images/solutions/solutions_direct-ads_mobile.png' : '/images/solutions/solutions_direct-ads.png'}
          imageAlt="Direct.Ads"
          bulletPoints={['Direct Mail', 'Email', 'In-Store Proximity Messaging']}
          imagePosition="right"
          firstCol='order-1 order-md-1'
          secondCol='order-2 order-md-2'
        />
      </SectionWrapper>

    
        <section className="hyperLink-section-8">
        <SectionWrapper style={{ background: 'linear-gradient(273.12deg, #0046BE 0%, #7026BF 121.29%)' }}>
          <Row className='hyperLink-section-pad'>
            <NavLink to={'/success-story'} className="nav-item solution-link-style">
              <div className="d-flex redirect-content">
                <div className="pe-2">See how clients win with Best Buy Ads</div>
                <div className="icon-space">
                  <i className="bi bi-arrow-right"></i>
                </div>
              </div>
            </NavLink>
          </Row>
          </SectionWrapper>
        </section>

    

      <SectionWrapper>
        <section className="section-9">
          <Row>
            <Col md={8} sm={12} className="">
              <div className="title-section-8">
                Close the loop with actionable, <span className='energy-purple'>performance-based </span> insights.
              </div>
              <div className="last-subsection">
                Our dedicated reporting and insights team taps into 1st-party data and advanced analytics to drive performance, while delivering enhanced reporting with transparency and speed.
              </div>
            </Col>
            <Col md={4} sm={12}>
              <AppImage src={isMobile ? '/images/solutions/solutions_insights_graphic_mobile.svg' : '/images/solutions/solutions_insights_graphic.svg'} alt="Close the loop with actionable, performance-based insights" title="Close the loop with actionable, performance-based insights" className="img-section-8" />
            </Col>
          </Row>
        </section>
      </SectionWrapper>

    </div>
  );
}

export default Solution;
